import axios from "axios";
import API from "../helpers/api";
import FileSaver from "file-saver";
import { toast } from "react-toastify";

let user = localStorage.getItem("UserRoles");

export const getShipDetail = (id, email) => {
  let url = `${API.ShipDetail}?ShipId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "TEFormApplicable",
          data: response.data.isTeFromApplicable,
        });
        // localStorage.setItem("TEFormApplicable", response.data.isTeFromApplicable);
        dispatch({
          type: "getShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShipDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPendingTask = (shipId, pageNo) => {
  let url = `${API.PendingTask}?ShipId=${shipId}&PageNumber=${pageNo}&PageSize=20`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPendingTaskSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPendingTaskFailure",
          error: "ERROR",
        });
      });
  };
};

export const getOtherTask = (shipId, pageNo) => {
  let mmpl = false;
  if (user === "admin" || user === "mmpl") {
    mmpl = true;
  }
  let url = `${API.GetOtherTask}?shipId=${shipId}&isMmpl=${mmpl}&PageNumber=${pageNo}&PageSize=20`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getOtherTaskSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getOtherTaskFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPendingTaskLineItems = (id) => {
  let url = `${API.PendingTaskLineItem}?POId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPendingTaskLineItemSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPendingTaskLineItemFailure",
          error: "ERROR",
        });
      });
  };
};

export const getIHMFullManual = (id) => {
  let url = `${API.IHMFullManual}?shipid=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        localStorage.setItem(
          "revisionId",
          response.data.latestUpdated.revisionId
        );
        dispatch({
          type: "getIHMFullManualSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getIHMFullManualFailure",
          error: "ERROR",
        });
      });
  };
};

export const getUpdatedIHMMaintenance = (id) => {
  // let url = `${API.IHMMaintenance}?shipid=${id}`;
  let items = {
    shipId: 1,
    revisionNo: " 56124",
    dateOfRevision: "2020-01-01",
    attachmentName: "qw23.pdf",
    attachmentGuid: "dfdsfwf4tr3f43r",
    createdBy: "SNR",
    CreatedDate: "2020-01-01",
    modifiedBy: "SNR",
    modofiedDate: "2020-01-01",
  };
  return (dispatch) => {
    // axios.get(url)
    //     .then((response) => {
    dispatch({
      type: "getIHMMaintenanceSuccess",
      data: items,
    });
    // })
    // .catch((error) => {
    //     dispatch({
    //         type: "getIHMMaintenanceFailure",
    //         error: "ERROR"
    //     })
    // })
  };
};
export const getRevisionHistory = (id) => {
  let url = `${API.RevisionHistory}?revisionId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getRevisionHistorySuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getRevisionHistoryFailure",
          error: "ERROR",
        });
      });
  };
};

export const getPOSearch = (item) => {
  let url = `${API.POSearch}?ShipId=${item.ShipId}&PoNo=${item.PONumber}&PoDateFrom=${item.PODateFrom}&PoDateTo=${item.PODateTo}&IhmPresence=${item.IHMPresense}&underReview=${item.underReview}&PageNumber=${item.pagenumber}&PageSize=${item.pageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getPOSearchDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getPOSearchDetailsFailure",
          error: "ERROR",
        });
      });
  };
};
export const getCertificates = (id) => {
  let url = `${API.Certificates}?shipid=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getCertificateHKCSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getCertificateHKCFailure",
          error: "ERROR",
        });
      });
  };
};

export const getCertificateEUSRR = (id) => {
  // let url = `${API.CertificateEUSRR}?shipid=${id}`;
  let items = {
    shipId: 1,
    issuedBy: "SNR",
    issuedDate: "2020-01-01",
    expiryDate: "2020-01-01",
    attachmentName: "qw23.pdf",
    attachmentGuid: "dfdsfwf4tr3f43r",
    createdBy: "SNR",
    CreatedDate: "2020-01-01",
    modifiedBy: "SNR",
    modofiedDate: "2020-01-01",
  };
  return (dispatch) => {
    // axios.get(url)
    //     .then((response) => {
    dispatch({
      type: "getCertificateEUSRRSuccess",
      data: items,
    });
    // })
    // .catch((error) => {
    //     dispatch({
    //         type: "getCertificateEUSRRFailure",
    //         error: "ERROR"
    //     })
    // })
  };
};
export const DownloadDocument = (attachmentDetail) => {
  let url = `${API.DownloadDoc}?attachmentname=${btoa(
    attachmentDetail.attachmentName
  )}&attachmentguid=${attachmentDetail.attachmentGuid}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, attachmentDetail.attachmentName);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "DownloadFailure",
          error: "ERROR",
        });
      });
  };
};
export const UpdatePendingTask = (data) => {
  let url = `${API.putPendingTask}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "putPendingTaskSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putPendingTaskFailure",
          error: "ERROR",
        });
      });
  };
};
export const UploadDocument = (postItem) => {
  const data = new FormData();
  data.append("file", postItem);

  let url = `${API.UploadDocs}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "UploadDocumentSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UploadDocumentFailure",
          error: "ERROR",
        });
      });
  };
};

export const ExportPO = (POSearch) => {
  let url = `${API.POExport}?PoNo=${POSearch.PONumber}&PoDateFrom=${POSearch.PODateFrom}&PoDateTo=${POSearch.PODateTo}&IhmPresence=${POSearch.IHMPresense}&underReview=${POSearch.underReview}&ShipId=${POSearch.ShipId}&PageNumber=${POSearch.pagenumber}&PageSize=${POSearch.pageSize}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, "Log");
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "DownloadFailure",
          error: "ERROR",
        });
      });
  };
};

export const ExportExcelPO = (POSearch) => {
  let url = `${API.POExportExcel}?ShipId=${POSearch.ShipId}&PoNo=${POSearch.PONumber}&PoDateFrom=${POSearch.PODateFrom}&PoDateTo=${POSearch.PODateTo}&IhmPresence=${POSearch.IHMPresense}&underReview=${POSearch.underReview}&PageNumber=${POSearch.pagenumber}&PageSize=${POSearch.pageSize}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, "Log");
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "DownloadFailure",
          error: "ERROR",
        });
      });
  };
};

export const ExportExcelShip = (ShipId) => {
  let url = `${API.ShipExportExcel}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, "AwaitingMD&SDoc");
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "DownloadFailure",
          error: "ERROR",
        });
      });
  };
};

export const ExportMDAndSDoc = (shipID) => {
  let url = `${API.POExportMDAndSDoc}?shipId=${shipID}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, "Log");
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "DownloadFailure",
          error: "ERROR",
        });
      });
  };
};

export const getSixMonthReview = (id) => {
  let url = `${API.GetSixMonthReview}?RevisionBySixMonthId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getSixMonthReviewSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getSixMonthReviewFailure",
          error: "ERROR",
        });
      });
  };
};

export const getSixMonthReviews = (id) => {
  let url = `${API.GetSixMonthReviews}?shipId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getSixMonthReviewsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getSixMonthReviewsFailure",
          error: "ERROR",
        });
      });
  };
};

export const postSixMonthReview = (data) => {
  let url = `${API.PostSixMonthReview}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postSixMonthReviewSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postSixMonthReviewFailure",
          error: "ERROR",
        });
      });
  };
};
